<template>
  <ContentWrapper v-if="mounted" class="container-fluid px-0 h-100">
    <!-- <pre style='font-size: 10px;'>screenWidth = {{ String(screenWidth) }}</pre> -->
    <!-- <pre style='font-size: 10px;'>screenSize = {{ String(screenSize) }}</pre> -->
    <!-- <pre style='font-size: 10px;'>detectDevice = {{ String(detectDevice) }}</pre> -->
    <template v-if="isReady">
      <HeaderPreview ref="header"></HeaderPreview>
      <MainBody class="d-flex">
        <div class="col p-0 d-flex flex-column">
          <slot></slot>
        </div>
      </MainBody>
    </template>
    <BlockLoading />
    <ModalReload />
  </ContentWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderPreview from "@components_system/Design/Header/HeaderPreview.vue";
import BlockLoading from "@components_system/Design/BlockLoading/BlockLoading.vue";
import ModalReload from "@components_system/Design/Modal/ModalReload/ModalReload";
import { ContentWrapper, MainBody } from "./Default.styled";
import siteService from "@services/siteService.js";
import userPreferenceService from "@services/userPreferenceService.js";

export default {
  head: {
    script: [
      { 
        src: "https://www.instagram.com/embed.js", 
        async: true, 
        defer: false 
      }
    ]
  },
  name: "design-preview-layout",
  data() {
    return {
      header_height: 56,
    };
  },
  components: {
    HeaderPreview,
    ContentWrapper,
    MainBody,
    BlockLoading,
    ModalReload,
  },
  computed: {
    ...mapGetters({
      screenSize: "screenSize",
      screenWidth: "screenWidth",
      detectDevice: "detectDevice",

      mounted: "mounted",
      initedSite: "design/site/inited",
      initedUserPreference: "design/userPreference/inited",
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
    }),
    isReady() {
      const isReady = this.initedSite && this.initedUserPreference;
      if (isReady) {
        this.$store.dispatch("design/unblockloading");
      } else {
        this.$store.dispatch("design/blockloading");
      }
      return isReady;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const requestSiteConfig = siteService.getSiteConfig();
      const requestGeneralConfig = userPreferenceService.getGeneralConfigs();
      const [ siteConfig, generalConfig ] = await Promise.all([requestSiteConfig, requestGeneralConfig]);
      
      this.$store.dispatch("design/site/init", { siteData: siteConfig });
      this.$store.dispatch("design/userPreference/init", { configs: generalConfig });
    }
  },
};
</script>

<style global lang="scss">
/* Css Layout DesignPreview */
@import "../assets/scss/mwe/editor-main.scss";

.ql-editor,
.nestable-handle {
  cursor: default;
}

/* legacy from php */
#section-content img {
  max-width: 100%;
}
.navigate {
  /* overflow-y: auto; */
  float: left;
  width: 200px;
  height: 100%;
  background-color: #373e44;
  left: -200px;
  -moz-transition: left 0.5s ease 0s;
  -webkit-transition: left 0.5s ease 0s;
  -o-transition: left 0.5s ease 0s;
  transition: left 0.5s ease 0s;
  position: fixed;
  z-index: 20;
}
.display {
  min-width: 320px;
  margin-left: 0px;
  height: 100%;
  position: relative;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  /* z-index: 26; */
}

#displayDeviceWrapper {
  border-radius: 0px;
  -moz-transition: border-radius 0.5s ease;
  -webkit-transition: border-radius 0.5s ease;
  -o-transition: border-radius 0.5s ease;
  transition: border-radius 0.5s ease;
}
.device.device-iphone-x #displayDeviceWrapper {
  border-radius: 40px;
}

#viewport {
  display: block;
  margin: 0 auto;
  border: 0px;
  padding: 0;
  height: 100%;
  vertical-align: bottom;
  overflow-x: hidden;
  min-width: 300px;
}
#viewport.loading {
  /* -webkit-filter: blur(4px);
  -moz-filter: blur(4px);
  -o-filter: blur(4px);
  -ms-filter: blur(4px);
  filter: blur(4px); */
  opacity: 0.2;
}
.viewportMobile {
  /*300px568px*/ /*414x736IP8PLUS*/
  height: 812px;
  width: 375px;

  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.nomaldisplay {
  height: 100%;
  width: 100%;
}
.device .device-space {
  height: 50px;
  background: #ccc;
  border-radius: 32px 32px 0 0 !important;
  position: relative;
}
.device .device-space .device-website {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 25px;
  text-align: center;
  color: green;
  font-size: 12px;
  vertical-align: middle;
  line-height: 25px;
}
.device .device-content {
  overflow: hidden;
  height: 600px !important;
  width: 298px !important;
  border-radius: 0 0 32px 32px !important;
}
.device.device-iphone-x #viewport {
  width: 100%;
  border-radius: 40px;
}
.device.device-iphone-x {
  /* background: #272a2a;*/
  /* padding: 20px 20px;*/
  /* border-radius: 1em;*/
  /*   border: 0.2142em solid #2b2f2f;*/
  margin: 2em auto 0 auto;
  /* height: 858px !important;*/
  /*  width: 425px !important;*/
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.device.device-ipad-pro {
  margin: 2em auto 0 auto;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.device.device-desktop {
  /* margin: 2em auto 0 auto; */
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.device-iphone-x .device-header::after {
  background: radial-gradient(
    circle at bottom left,
    transparent 0,
    transparent 70%,
    #222 75%,
    #222 100%
  ) !important;
}
.device-iphone-x .device-header::before {
  background: radial-gradient(
    circle at bottom right,
    transparent 0,
    transparent 70%,
    #222 75%,
    #222 100%
  ) !important;
}
.device-iphone-x .device-frame {
  margin: 0 auto;
  transition: all 0.5s ease;
}
.device-ipad-pro .device-frame {
  margin: 0 auto;
  transition: all 0.2s ease;
}
.device-desktop .device-frame {
  margin: 0 auto;
  transition: all 0.2s ease;
}
.viewportMobile.landscape {
  height: 375px;
  width: 812px;
}
#viewport.viewportTablet {
  /*768px*/
  height: 1024px;
  width: 768px;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}
.viewportTablet.landscape {
  height: 768px;
  width: 1024px;
}
.viewportDesktop {
  height: 100%;
  /*                max-height: 802px;  */
  width: 100%;
  -moz-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.areacontext .btn-primary {
  background: #373e44 !important;
  color: #fff !important;
  border-color: #23292f !important;
}
.areacontext .btn-primary:hover,
.areacontext .btn-primary:focus {
  color: #fff !important;
  background-color: #202428 !important;
  border-color: #090a0c !important;
}

#divEngineLanguageSelectors span:hover {
  cursor: pointer;
  text-decoration: underline;
}

.preview-containerTablet {
  height: 1184px;
  width: 928px;
  background: #272a2a;
  padding: 80px 80px;
  border-radius: 3em;
  border: 0.2142em solid #2b2f2f;
  margin: 4em auto;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.preview-containerIphone {
  width: 375px;
  height: 812px;
  background: #272a2a;
  padding: 80px 30px;
  border-radius: 3em;
  border: 0.5714em solid #2b2f2f;
  display: block;
  margin: 4em auto;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

/* backtotop */
a:focus {
  outline: 0;
}
.back-to-top {
  background: transparent;
  margin: 0;
  position: fixed;
  bottom: 55px;
  opacity: 0.7;
  right: 29px;
  z-index: 100;
  text-decoration: none;
  color: #ffffff;
}
#toTop.fa-stack {
  width: 4em;
  height: 4em;
  line-height: 4em;
}
#toTop > .fa-stack-1x {
  font-size: 2em !important;
}
#toTop > .fa-stack-2x {
  font-size: 4em !important;
}
.back-to-top i.fa-circle {
  color: #2b2a2a;
}
.back-to-top:hover i.fa-circle {
  opacity: 0.8;
}

/*#divViewportLoading {
    transition: all 0.5s ease 0s;
    -moz-transition: all 0.5s ease 0s;
    -webkit-transition: all 0.5s ease 0s;
    -o-transition: all 0.5s ease 0s;
    opacity: 0;
    height: 100%;
    position: fixed;
    width: 100%;
    background: transparent;
    z-index: -1;
}
#divViewportLoading.active {
    background: #efefef;
    opacity: 1;
    z-index: 9999;
}*/
#section-content .container-fluid,
#section-content .container {
  opacity: 1;
}
/*.input-group.date .input-group-addon {
    background-color: inherit !important;
    color: inherit !important;
    border: inherit !important
}*/

.marginBot {
  margin-bottom: 50px;
}
#divMWEAds {
  bottom: unset;
  width: 100vw !important;
  background: #fff;
  color: #000;
}
#divMWEAds:hover {
  cursor: pointer;
  background: #fff;
}
#divMWEAds img {
  max-height: 40px;
  max-width: 40px;
}
#divMWEAds .btnMWE {
  border: 1px solid #fbae00;
  color: #fbae00;
  background: transparent;
}
#divMWEAds .spanFree {
  color: #fbae00;
  text-decoration: underline;
}
#section-engine {
  color: #353535;
  font-family: "Tahoma" !important;
  font-size: 12px;
  background: #ffffff;
  height: 20px;
  line-height: 20px;
  display: block;
  vertical-align: middle;
  text-align: center;
}
#section-engine .spanMWE {
  cursor: pointer;
  color: #28bee3;
  font-weight: bold;
}
.divHelpButton {
  position: absolute;
  right: 20px;
  top: 20px;
}
.helpButtonBackend {
  vertical-align: sub;
  color: #000;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  text-shadow: 0 1px 0 #fff;
}
.helpButtonBackend:hover {
  color: #373e44;
}

body > .container-fluid {
  background: #f4f7f9;
  min-height: 100vh;
}
textarea {
  min-height: 34px;
  resize: vertical;
}

.panel-custom-round {
  border-radius: 10px !important;
}
.panel-custom-round-form {
  border-radius: 6px !important;
}
.round-6 {
  border-radius: 6px !important;
}
.round-10 {
  border-radius: 10px !important;
}

/* Panel - Backend Help*/
.helperbackend .collapseHelpHead {
  background-color: #2a9ae0 !important;
  color: #ffffff !important;
  font-family: "MWE_DB_Heavent";
  padding: 2px 15px;
  cursor: pointer;
  border-radius: 0px;
}
.helperbackend .collapseHelpHead .collapseHelpHeadText {
  font-size: 24px;
}
.helperbackend .icoCollapseHelp {
  margin-top: 6px;
}
.helperbackend .panel-help-round {
  border-radius: 6px !important;
  overflow: hidden;
  border: 1px solid #2a9ae0 !important;
}
.helperbackend .panel-title .icoCollapseHelp::before {
  font-family: "Font Awesome 5 Pro";
  content: "\f068";
  font-weight: 900;
}
.helperbackend .panel-title.collapsed .icoCollapseHelp::before {
  font-family: "Font Awesome 5 Pro";
  content: "\f067" !important;
}
.helperbackend .manualHelp {
  font-family: "MWE_DB_Heavent";
  font-size: 18px;
}
.helperbackend .manualHelp .manualText {
  font-weight: bold;
  color: #373e44;
}
.helperbackend .manualHelp .manualText i {
  font-size: 16px;
}
.helperbackend .manualHelp .manualLink {
  font-weight: bold;
  color: #2a9ae0;
  text-decoration: underline;
}

/* Form Control */
.has-error .form-control {
  border-color: #f7381e;
}
.has-error .form-control:focus {
  border-color: #f7381e;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ef6461;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ef6461;
}
.has-error .help-block,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline,
.has-error.radio label,
.has-error.checkbox label,
.has-error.radio-inline label,
.has-error.checkbox-inline label {
  color: #f7381e;
}

/* Toggle */
.toggle {
  margin-top: 5px;
}

/* Table - P'Tum */
.ul-form-panel {
  border: 1px solid #dddddd;
  background-color: #ffffff;
}

/* Table */
.inner-table-responsive {
  width: 100%;
  min-width: 1024px;
}
.ulDataHeader {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.ulDataHeader > li {
  width: 100%;
  height: auto;
  position: relative;
  display: table;
  padding: 0 10px;
}
.ulDataHeader > li > span {
  padding: 10px 5px;
  display: table-cell;
  vertical-align: bottom;
}
.ulDataBody {
  width: 100%;
  margin: 0 0 15px 0;
  padding: 0;
  list-style-type: none;
}
.ulDataBody > li {
  width: 100%;
  height: auto;
  position: relative;
  display: table;
  padding: 0 10px;
}
.ulDataBody > li > span {
  padding: 10px 5px;
  display: table-cell;
  vertical-align: top;
}
.ulDataBody > li.danger {
  background-color: #ffe3e2 !important;
}
@media screen and (max-width: 767px) {
  .inner-table-responsive {
    padding: 15px;
  }
}
/* Table Theme */
.ul-header-form-panel {
}
.ul-header-form-panel li {
  font-family: "MWE_DB_Heavent";
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
}
.ul-body-form-panel {
}
.ul-body-form-panel li {
  background-color: #ffffff;
  border: 1px solid #dddddd;
  margin-bottom: -1px;
}
.ul-body-form-panel li:hover {
  background-color: #eaf0f3;
}
.ul-body-form-panel li:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.ul-body-form-panel li:last-child {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  margin-bottom: 0;
}
.ul-body-form-panel li.placeholder:nth-child(2) {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.ul-body-form-panel li.placeholder:nth-last-child(2) {
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  margin-bottom: 0;
}

/* Select-picker category 4lv */
.selectpicker .level-2 {
  padding-left: 35px;
}
.selectpicker .level-3 {
  padding-left: 50px;
}
.selectpicker .level-4 {
  padding-left: 65px;
}

/* Tab */
.tabError.active > a,
.tabError.active > a:focus,
.tabError.active > a:hover {
  background-color: #fff !important;
  color: #f7381e !important;
}
.tab-content {
  background-color: #ffffff;
  padding: 15px 15px;
  position: static;
}
.tab-content-form-panel {
  background-color: #ffffff;
  padding: 15px 15px;
  border-top: none;
  border-left: 1px solid #cad0d3;
  border-right: 1px solid #cad0d3;
  border-bottom: 1px solid #cad0d3;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.display-contents {
  display: contents;
}
body {
  font-size: 1rem;
  margin: 0;
  height: 100vh;
}
iframe {
  border: unset;
}
#app {
  height: 100%;
}
.shadow-x {
  border-right: 1px solid #e1e5ea;
  border-left: 1px solid #e1e5ea;
  box-shadow: -12px 0 24px -5px rgba(132, 146, 166, 0.16),
    12px 0 24px -5px rgba(132, 146, 166, 0.16);
}
.shadow-l {
  border-right: 1px solid #e1e5ea;
  border-left: 1px solid #e1e5ea;
  box-shadow: -12px 0 24px -5px rgba(132, 146, 166, 0.16);
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.content-view {
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  min-height: 100%;
}

.center-hv {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/* <?php if ($resultGetSiteConfig['IsCopyProtection'] == 1) { ?> 
                body{
                    -webkit-touch-callout: none;
                    -webkit-user-select: none;  
                    -moz-user-select: none;     
                    -ms-user-select: none;      
                    user-select: none;          
                                                
                }
                .coupon-label-codetocopy, #promotionCode{
                    -webkit-touch-callout: text !important;
                    -webkit-user-select: text !important;
                    -moz-user-select: text !important;
                    -ms-user-select: text !important;
                    user-select: text !important; 
                }
            <?php } ?> */
.pagination > li > a,
.pagination > li > span {
  font-size: 14px;
  color: inherit;
}
.dropdown.areacontext.open {
  z-index: 1001 !important;
}
.table-responsive table {
  margin-bottom: 20px;
  white-space: nowrap;
}
@media only screen and (min-width: 1200px) {
  .table-responsive table {
    white-space: normal;
  }
}
@media only screen and (min-width: 1200px) {
  .section-container > .slimScrollDiv {
    display: none;
  }
}
a[data-mce-href] {
  font-size: inherit;
  font-family: inherit;
  /*color: inherit;*/
}
/* areacontext menu */
.areacontext {
  border: 1px solid rgb(9, 10, 12);
}
.areacontext .btn-primary {
  background: #373e44 !important;
  color: #fff !important;
  border-color: #23292f !important;
  padding: 1px 5px;
  display: block;
}
.areacontext > div {
  font-family: Open Sans !important;
  font-size: 12px !important;
}
.areacontext ul.dropdown-menu {
  border-radius: 0px !important;
  background: #373e44 !important;
  margin-top: 0px !important;
  border: 1px solid rgb(9, 10, 12);
  padding: 0px !important;
  min-width: 100px !important;
  transform: translate3d(-1px, 20px, 0px) !important;
}
.areacontext ul.dropdown-menu > li > a {
  font-family: "Tahoma" !important;
  font-size: 12px !important;
  color: rgb(145, 159, 174) !important;
  padding: 3px 5px !important;
  display: block;
}
.areacontext ul.dropdown-menu > li > a:hover {
  background: #262d33 !important;
  color: #fff !important;
  text-decoration: none;
}
/* addition */
/* facebook like box */
.fb-like.fb_iframe_widget > span > iframe {
  max-width: none !important;
}
/* img in table */
table img {
  max-width: initial !important;
}

/* pagination */
.pagination > li > a,
.pagination > li > span {
  font-size: 14px;
  color: inherit;
}
/* table */
.table-responsive table {
  margin-bottom: 20px;
  white-space: nowrap;
}
@media only screen and (min-width: 1200px) {
  .table-responsive table {
    white-space: normal;
  }
}
/* img width and rendering */
/* div#section-content img:not(.fill),
div#section-footer img:not(.fill) {
  overflow: hidden;
  opacity: 0;
  -webkit-transition: opacity 0.3s ease-in-out,
    -webkit-transform 0.3s ease-in-out;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  max-width: 100%;
  image-rendering: -webkit-optimize-contrast;
} */
@media (max-width: 768px) {
  body {
    max-width: 100vw;
  }
}
/* force show img */
.map_outter img {
  opacity: 1 !important;
}

/* top layout */
nav > #comp-HEADER_AREA > .container-fluid {
  padding-left: 8px;
  padding-right: 8px;
}
nav > #comp-HEADER_AREA > .row {
  margin: 0;
}
nav > #comp-HEADER_AREA > .row > .col {
  padding: 0;
}
.navbar-link {
  display: inline-block;
  padding: 8px;
  border: none;
  margin: 8px 0px;
  vertical-align: middle;
  line-height: 1;
}
/*.navbar-fa {
                width: 24px !important;
                height: 24px !important;
            }*/
.navbar-toggler-icon {
  margin: 0;
  padding: 0;
}
.dropdown > .dropdown-toggle > svg {
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
}
.dropdown.show > .dropdown-toggle > svg.arrow {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -o-transform: rotate(180deg);
}
.dropdown-menu > li > .dropdown-toggle > svg {
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
}
.dropdown-menu > li.show > .dropdown-toggle > svg {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
}
/* cart widget */
nav span.fa-layers.fa-fw > i.navbar-fa + span.fa-layers-counter {
  display: none;
}
nav span.fa-layers.fa-fw > svg.navbar-fa + span.fa-layers-counter {
  -webkit-transform: scale(0.75) !important;
  transform: scale(0.75) !important;
  top: -75%;
  right: auto;
  left: 50%;
  -webkit-transform-origin: top center;
  transform-origin: top center;
  display: inline-block;
}
/* hide caret */
.dropdown-toggle::after {
  display: none !important;
}
/* vertical align text widget */
.navbar-text {
  line-height: 150%;
  vertical-align: middle;
  min-height: 50px;
}
@media (min-width: 401px) {
  .navbar-text {
    min-height: 56px;
  }
}
</style>